import { bindings } from '@polleverywhere/slideware-bindings'

export default async function openWindow (url, state) {
  if (state.get('mode') === 'integration') {
    await bindings.openBrowser({ url })
  } else {
    const features = 'noopener'
    window.open(url, '_system', features)
  }
}
